import { ReactElement } from 'react';
import { CrmFieldResponse, LookupResponse } from 'common/interfaces';
import { Link } from 'react-router-dom';
import { PAGES } from 'common/enums';
import classes from './notification.module.scss';

export const injectLink = (text: string, regardingObject: CrmFieldResponse<LookupResponse>): ReactElement => {
  const { name: invoiceNumber, id: invoiceId } = regardingObject || {};

  if (invoiceNumber && text.includes(invoiceNumber)) {
    const textParts = text.split(invoiceNumber);

    return (
      <>
        {textParts[0]}
        <Link className={classes['notification__link']} to={`${PAGES.EINGANGSRECHNUNG_EDIT}?id=${invoiceId}`}>
          {invoiceNumber}
        </Link>
        {textParts[1]}
      </>
    );
  }

  return <>{text}</>;
};
